export type CatalogCategory = string;
export type EquipmentSlot = string;
export type InventoryGrantSource = 'purchase' | 'administrative_grant' | 'claim' | 'migration' | 'starter';
export type GoalExplosionSelectionMode = 'shuffle-bag' | 'random';

/** Identity and ownership do not change when presentation or commercial terms change. */
export interface CatalogItem {
  readonly id: string;
  readonly category: CatalogCategory;
  readonly revision: number;
  readonly name: string;
  readonly slug: string;
  readonly status: 'draft' | 'published' | 'disabled';
  readonly priceCents: number;
  readonly currency: 'usd';
  readonly includedInStarterInventory: boolean;
}

export interface EquipmentSelection {
  readonly itemIds: readonly string[];
}

export type EquipmentSlots = Readonly<Record<EquipmentSlot, EquipmentSelection>>;

export interface EquipmentLoadout {
  readonly version: number;
  readonly slots: EquipmentSlots;
}

export interface UpdateEquipmentLoadout {
  readonly expectedVersion: number;
  readonly slots: EquipmentSlots;
}

export interface ClaimCatalogItem {
  readonly itemId: string;
  readonly expectedCatalogRevision: number;
}

export interface InventorySnapshot {
  readonly items: readonly CatalogItem[];
  readonly ownedItemIds: readonly string[];
  readonly loadout: EquipmentLoadout;
  readonly slotDefinitions: readonly EquipmentSlotDefinition[];
}

export interface EquipmentSlotDefinition {
  readonly id: EquipmentSlot;
  readonly category: CatalogCategory;
  readonly maxItems: number;
  readonly minItems: 0 | 1;
  readonly initialItemIds: readonly string[];
}

export interface InventorySettings {
  readonly revision: number;
  readonly goalExplosionSelectionMode: GoalExplosionSelectionMode;
}

export const MAX_GOAL_EXPLOSION_SELECTION = 32;

export interface EquipmentSlotPolicyInput {
  readonly id: EquipmentSlot;
  readonly minItems: 0 | 1;
  readonly initialItemIds: readonly string[];
}

export interface InventoryPolicy {
  readonly revision: number;
  readonly slots: readonly EquipmentSlotDefinition[];
  readonly starterItemIds: readonly string[];
}

export interface UpdateInventoryPolicy {
  readonly expectedRevision: number;
  readonly slots: readonly EquipmentSlotPolicyInput[];
  readonly starterItemIds: readonly string[];
}

export interface InventoryPolicySnapshot {
  readonly policy: InventoryPolicy;
  readonly items: readonly CatalogItem[];
}
